<template>
  <Layout>
    <Banner />
    <Collections />
    <ProductsSection title="新品上市" subtitle="New Arrivals" productType="new" />
    <ProductsSection title="熱銷榜單" subtitle="ＲＡＮＫＩＮＧ" productType="sale" />
    <NewsSection />
  </Layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue'
import Banner from '@/components/home/Banner.vue'
import Collections from '@/components/home/Collections.vue'
import ProductsSection from '@/components/home/ProductsSection.vue'
import NewsSection from '@/components/home/NewsSection.vue'

export default {
  name: 'Home',
  components: {
    Layout,
    Banner,
    Collections,
    ProductsSection,
    NewsSection
  }
}
</script> 